import { UliDetailsPreviewCriteria } from '../models/uli-details.model';

export class UliDetailsLoad {
  public static readonly type = '[UliDetails] Load';

  constructor(public payload: UliDetailsPreviewCriteria) {}
}

export class UliDetailsInitialState {
  public static readonly type = '[UliDetails] Set Initial State';
}
